"use client";

import React, { useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

interface MagicCodeInputProps {
  onSubmit: (code: string) => void;
  isPending: boolean;
}

export default function MagicCodeInput({ onSubmit, isPending }: MagicCodeInputProps) {
  const [code, setCode] = useState("");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (code.length === 6) {
      onSubmit(code);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <label htmlFor="magic-code" className="sr-only">Magic link code</label>
      <Input
        textShortcuts={false}
        id="magic-code"
        type="text"
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
        placeholder="Enter 6-digit code"
        required
        inputMode="numeric"
        pattern="^\d{6}$"
        autoComplete="one-time-code"
        autoFocus
        testId="magic-code-input"
        variant="onboarding"
        fontSize="sm"
        inputClassName="px-0 text-center tracking-[0.5em] font-mono"
      />
      <Button
        type="submit"
        disabled={isPending || code.length !== 6}
        data-testid="magic-code-submit-button"
        className="w-full"
      >
        {isPending ? "Verifying..." : "Verify code"}
      </Button>
    </form>
  );
}
